const initCmsContentFixer = () => {
  const contextElement = document.getElementById("content-source");
  if (contextElement) {
    wrapTablesInCMSContent(contextElement);
  }
};
const wrapTablesInCMSContent = (contextElement) => {
  Array.from(contextElement.querySelectorAll("table")).forEach((table) => {
    table.outerHTML = `<div class="o-scroll-wrapper">${table.outerHTML}</div>`;
  });
};

export { initCmsContentFixer };
